// Axios configuration - must be imported before any component that uses axios
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

export const API = `${BACKEND_URL}/api`;

axios.defaults.withCredentials = true;

// Set up axios to use the legacy bearer token only when present.
// Web sessions use the HttpOnly session cookie set by the API.
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default axios;
